import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getCampaignSelection } from 'components/marketing/EmailCampaign/selectors';
import PromotionalOffers from './';
import { resetCampaignSelectionFlow } from '../actions';

const mapStateToProps = (state) => ({
  campaignSelection: getCampaignSelection(state),
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      resetCampaignSelectionFlow,
    },
    dispatch,
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(PromotionalOffers);
